/* eslint-disable no-magic-numbers */
import { Pipe, PipeTransform } from '@angular/core';

const SOCIAL_SECURITY_NUMBER_LENGTH = 11;

@Pipe({
    name: 'socialSecurityNumberDisplay',
    standalone: false,
})
export class SocialSecurityNumberDisplayPipe implements PipeTransform {
    transform(value?: string): string | undefined {
        if (value == undefined || value == '') {
            return undefined;
        }
        let valWithoutSeparators = value.replace(/\D/gi, '');
        // Add xxxx to fix the length if an invalid value was given
        if (valWithoutSeparators.length < SOCIAL_SECURITY_NUMBER_LENGTH) {
            valWithoutSeparators += 'x'.repeat(SOCIAL_SECURITY_NUMBER_LENGTH - valWithoutSeparators.length);
        }
        let formattingRegexp = /(?<year>..)(?<month>..)(?<day>..)(?<group3>...)(?<group2>..)(?<groupx>.*)/;
        const result = valWithoutSeparators.match(formattingRegexp)?.groups;
        return `${result?.year ?? 'xx'}.${result?.month ?? 'xx'}.${result?.day ?? 'xx'}-${result?.group3 ?? 'xxx'}.${
            result?.group2 ?? 'xx'
        }${result?.groupx ?? ''}`;
    }
}
